import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginHeaderComponent} from './components/login-header/login-header.component';
import {FooterComponent} from './components/footer/footer.component';
import {PageNotFoundComponent} from './pages/page-not-found/page-not-found.component';
import {AppRoutingModule} from '../app-routing.module';

@NgModule({
  declarations: [
    LoginHeaderComponent,
    FooterComponent,
    PageNotFoundComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule
  ],
  exports: [
    LoginHeaderComponent,
    FooterComponent,
    PageNotFoundComponent
  ]
})
export class SharedModule { }
